import React from "react";

/**
 * SegmentedControl "Activas | Finalizadas" with counts. It works as tabs (role="tab" + aria-selected) that
 * control the results panel; arrow keys move between segments.
 */
export const segmentId = (idPrefix, value) => `${idPrefix}-${value}`;

export default function SegmentedControl({ label, options, value, onChange, controls, idPrefix }) {
  const handleKeyDown = (event) => {
    if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
    event.preventDefault();
    const index = options.findIndex((option) => option.value === value);
    const step = event.key === "ArrowRight" ? 1 : -1;
    const next = options[(index + step + options.length) % options.length];
    onChange(next.value);
    const target = event.currentTarget.querySelector(`[data-vista="${next.value}"]`);
    target?.focus();
  };

  return (
    <div className="crm-rollo__seg" role="tablist" aria-label={label} onKeyDown={handleKeyDown}>
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            id={segmentId(idPrefix, option.value)}
            data-vista={option.value}
            aria-selected={selected}
            aria-controls={controls}
            tabIndex={selected ? 0 : -1}
            className="crm-rollo__seg-btn"
            onClick={() => onChange(option.value)}
          >
            {option.label}
            <span className="crm-rollo__count">{option.count ?? "—"}</span>
          </button>
        );
      })}
    </div>
  );
}
